module.exports = __webpack_public_path__ + "media/images/promo/energizer/notification-3bed67b370bd04b43d2f0028370f4f1c.png";